import React from 'react';
import './ServicePages.css';

const RagPage = ({ onContactClick }) => {
  const features = [
    { icon: "📚", title: "Knowledge Base Indexing", desc: "Ingest and index your documents, PDFs, databases, and wikis for instant AI-powered retrieval." },
    { icon: "🔍", title: "Semantic Search", desc: "Go beyond keyword matching — find relevant information based on meaning and context." },
    { icon: "🎯", title: "Grounded Responses", desc: "Generate AI answers that are always backed by your actual data, eliminating hallucinations." },
    { icon: "🔄", title: "Real-Time Sync", desc: "Keep your knowledge base up-to-date with automatic syncing from your source systems." },
    { icon: "🔐", title: "Access Controls", desc: "Ensure users only retrieve information they're authorized to see with role-based filtering." },
    { icon: "⚡", title: "Low-Latency Retrieval", desc: "Sub-second retrieval from millions of documents using optimized vector databases." }
  ];

  return (
    <div className="service-page theme-rag">
      <section className="svc-hero">
        <div className="svc-hero-content">
          <h1 className="svc-hero-title">RAG<br/>Services</h1>
          <p className="svc-hero-subtitle">RETRIEVAL-AUGMENTED GENERATION FOR ENTERPRISE AI.</p>
          <p className="svc-hero-desc">Build AI systems that retrieve real-time knowledge from your data and generate accurate, contextual answers — no hallucinations.</p>
          <div className="svc-hero-stats">
            <div className="svc-stat-item"><h3>99%</h3><p>Answer Accuracy</p></div>
            <div className="svc-stat-item"><h3>{'<1s'}</h3><p>Retrieval Latency</p></div>
            <div className="svc-stat-item"><h3>0</h3><p>Hallucinations</p></div>
          </div>
          <div className="svc-hero-cta">
            <button className="svc-btn-primary" onClick={onContactClick}>Book a Call</button>
            <button className="svc-btn-secondary"><span>▶</span> See Demo</button>
          </div>
        </div>
        <div className="svc-hero-visual">
          <div className="svc-glowing-ring">📚</div>
        </div>
      </section>

      <section className="svc-features-section">
        <h2 className="svc-section-title">RAG Platform Capabilities</h2>
        <div className="svc-features-grid">
          {features.map((f, i) => (
            <div key={i} className="svc-feature-card">
              <div className="feature-icon">{f.icon}</div>
              <h3 className="feature-title">{f.title}</h3>
              <p className="feature-desc">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="svc-cta-section">
        <div className="svc-cta-content">
          <h2>Ready to ground your AI in real data?</h2>
          <p>Book a call and we'll build a RAG pipeline tailored to your knowledge base.</p>
          <button className="svc-btn-cta" onClick={onContactClick}>Book a Call</button>
        </div>
      </section>
    </div>
  );
};

export default RagPage;
